import styles from './StatusPill.module.css';

export type DotColor = 'blue' | 'amber' | 'green' | 'red' | 'teal';

const dotClass: Record<DotColor, string> = {
  blue: styles.dotBlue,
  amber: styles.dotAmber,
  green: styles.dotGreen,
  red: styles.dotRed,
  teal: styles.dotTeal,
};

export interface StatusPillProps {
  color: DotColor;
  label: string;
  count: number;
  active?: boolean;
  onClick?: () => void;
}

export function StatusPill({ color, label, count, active, onClick }: StatusPillProps) {
  return (
    <button
      type="button"
      className={`${styles.pill} ${active ? styles.active : ''}`}
      onClick={onClick}
    >
      <span className={`${styles.dot} ${dotClass[color]}`} />
      <span className={styles.label}>{label}</span>
      <span className={styles.count}>{count}</span>
    </button>
  );
}
